function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
const SvgQFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 2",
  viewBox: "0 0 1080 1076.59",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 491.87C0 235.24 184.45 0 495.88 0s494.55 235.24 494.55 491.87-184.46 491.87-494.55 491.87S0 748.5 0 491.87Zm769.88 0c0-153.71-104.25-296.73-274-296.73s-274 143.02-274 296.73 102.92 296.73 274 296.73 274-143.02 274-296.73Z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M922.32 859.3h98.06c32.9 0 59.61 26.71 59.61 59.61v98.06c0 32.9-26.71 59.61-59.61 59.61h-98.07c-32.9 0-59.61-26.71-59.61-59.61v-98.06c0-32.9 26.71-59.61 59.61-59.61Z",
  style: {
    fill: "#49d8f7"
  }
})));
const Memo = /*#__PURE__*/memo(SvgQFilled);
export default Memo;